import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { of } from 'rxjs';
import { catchError, take } from 'rxjs';
import { AlertToastService } from '@services';
import { AbstractFormContainer } from '@shared/classes/abstract-form-container';
import { isNullish } from '@shared/utils/helpers.util';
import { BusinessSettingsService } from '../../../../dashboard/settings/services/business-settings.service';
import { CustomReturnAddressComponent } from '../custom-return-address/custom-return-address.component';

@Component({
  selector: 'app-custom-backwards-delivery-address',
  templateUrl: './custom-backwards-delivery-address.component.html',
  styleUrls: ['./custom-backwards-delivery-address.component.scss'],
})
export class CustomBackwardsDeliveryAddressComponent extends AbstractFormContainer implements OnInit, OnDestroy {
  private _cargoType: string = null;
  private _customAddresses: any[] = null;
  private _ref: string = null;

  @ViewChild('customAddress', {read: CustomReturnAddressComponent}) customAddress;
  @Input() isCorporate = false;
  @Input() controlName = 'BackwardDeliveryData';
  @Input() templateValidation: boolean;
  @Input() stepDeliveryForm: UntypedFormGroup;
  backwardDeliveryDataGroup: UntypedFormGroup;
  backDeliveryGroup: UntypedFormGroup;

  returnAddressControlName = 'CustomBackwardDeliveryParameterCustomAddress';

  constructor(
    protected formBuilder: UntypedFormBuilder,
    private settingService: BusinessSettingsService,
    private cd: ChangeDetectorRef,
    private alertToastService: AlertToastService,
  ) {
    super();
  }

  @Input() set cargoType(value: string) {
    const previousCargoType = this._cargoType;
    const hasChanged = !isNullish(previousCargoType) && previousCargoType !== value;

    this._cargoType = value;

    if (hasChanged && !!value && this.isCorporate) {
      this.getReturnAdresses(this._ref, value);
    }
  }

  get cargoType(): string {
    return this._cargoType;
  }

  @Input() set ref(ref: string) {
    this._ref = ref;
    if (this.isCorporate) {
      this.getReturnAdresses(ref, this.cargoType);
    }
  }

  get ref() {
    return this._ref;
  }

  get customAddresses() {
    return this._customAddresses;
  }

  set customAddresses(addresses) {
    if (!addresses && this.isCorporate) {
      this.updateRef(null);
    }
    this._customAddresses = addresses;
  }

  getReturnAdresses(ref: string, cargoType: string) {
    this.settingService.getReturnAdresses(ref, cargoType, 'CargoReturn')
      .pipe(take(1),
        catchError(e => of(e)))
      .subscribe(data => {
        if (!data.length) {
          this.alertToastService.pushError('Відсутні нестандартні адреси повернення');
          this.backDeliveryGroup.patchValue({
            selected: false,
          });
        }
        this.customAddresses = data.length > 0 ?
          data.map(el => ({
            label: el.Address,
            value: el.Ref,
          })) : '';
        this.cd.detectChanges();
      });
  }

  ngOnInit(): void {
    super.ngOnInit();
    if (this.templateValidation) {
      const formGroup = this.form.get('AdditionalServices.customBackwardsDeliveryAddress').get(this.controlName);
      Object.keys(formGroup['controls']).forEach(key => formGroup['controls'][key].clearValidators());
    }

  }

  updateRef(ref: string): void {
    this.backwardDeliveryDataGroup.get('CustomBackwardDeliveryParameterCustomAddress').setValue(ref);
  }

  addFormControls(): void {
    this.backDeliveryGroup = (this.form.get('AdditionalServices').get('customBackwardsDeliveryAddress') as UntypedFormGroup);
    this.backwardDeliveryDataGroup = this.formBuilder.group({
      CargoType: [this.cargoType, [
        Validators.required,
      ]],
      CustomBackwardDeliveryParameterCustomAddress: [''],
    });
    this.backDeliveryGroup.addControl(this.controlName, this.backwardDeliveryDataGroup);
  }

  ngOnDestroy(): void {
    this.backDeliveryGroup.removeControl(this.controlName);
  }
}
